import { TeamTaskForm } from '@macs-frontend/web-macs/shared';
import { FormArrayState, FormGroupState } from 'ngrx-forms';
import { ActionPlanningForm } from '../../company-management/projects/reducers/action-planning';
import { ChannelsForm } from '../../company-management/projects/reducers/channels';
import { MTMaterialGroupForm } from '../../company-management/projects/reducers/materials-management';
import { GeneralInfoForm } from '../../manage-project-shared/reducers/general-info.reducer';

export function isGeneralInfoPristine({
  generalInfoForm,
}: {
  generalInfoForm?: FormGroupState<GeneralInfoForm>;
}) {
  return () => generalInfoForm?.isPristine || generalInfoForm?.isSubmitted;
}

export function isChannelSuggestionPristine({
  channelsForm,
  generalInfoForm,
  resetStateOnDestroy,
}: {
  channelsForm?: FormGroupState<ChannelsForm>;
  generalInfoForm?: FormGroupState<GeneralInfoForm>;
  resetStateOnDestroy?: boolean;
}) {
  return () =>
    (!channelsForm?.isDirty && isGeneralInfoPristine({ generalInfoForm })()) ||
    !resetStateOnDestroy ||
    channelsForm?.isSubmitted;
}

export function isMaterialsManagementPristine({
  materialsManagementForm,
}: {
  materialsManagementForm?: FormArrayState<MTMaterialGroupForm>;
}) {
  return () =>
    materialsManagementForm?.isUntouched ||
    materialsManagementForm?.isPristine ||
    materialsManagementForm?.isSubmitted;
}

export function isActionPlanningPristine({
  actionPlanningForm,
}: {
  actionPlanningForm?: FormGroupState<ActionPlanningForm>;
}) {
  return () => actionPlanningForm?.isPristine || actionPlanningForm?.isSubmitted;
}

export function isTeamTaskPristine({
  teamTaskForm,
}: {
  teamTaskForm?: FormGroupState<TeamTaskForm>;
}) {
  return () => teamTaskForm?.isPristine || teamTaskForm?.isSubmitted;
}

export const canDeactivateModules = (forms: {
  generalInfoForm?: FormGroupState<GeneralInfoForm>;
  channelsForm?: FormGroupState<ChannelsForm>;
  materialsManagementForm?: FormArrayState<MTMaterialGroupForm>;
  actionPlanningForm?: FormGroupState<ActionPlanningForm>;
  teamTaskForm?: FormGroupState<TeamTaskForm>;
  resetStateOnDestroy?: boolean;
}) => [
  isGeneralInfoPristine(forms),
  isChannelSuggestionPristine(forms),
  isMaterialsManagementPristine(forms),
  isActionPlanningPristine(forms),
  isTeamTaskPristine(forms),
];
